module.exports = __webpack_public_path__ + "static/img/bg.db6fd7a8.png";